import { isString } from '@vue/shared'

export const selectProps = {
  /** 基础功能 */
  type: {
    type: String,
    default: 'text',
  },
  modelValue: {
    type: String,
    default: '',
  },
  defalutValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },

  /** UI相关 */
  width: {
    type: Number,
    default: 100,
  },
  height: {
    type: Number,
    default: 0,
  },
  placeholder: {
    type: String,
    default: '',
  },
  dropWidth: {
    type: Number,
    default: 0,
  },
  dropBackground: {
    type: String,
    default: '',
  },
  selectWrapperStyle: {
    type: Object,
    default: {},
  },
  selectInnterStyle: {
    type: Object,
    default: {},
  },
  suffixWidthOffset: {
    type: Number,
    default: 0,
  },

  /** 拓展功能 */
  allowClear: {
    type: Boolean,
    default: false,
  },
  // 是否可更改选择值
  readonly: {
    type: Boolean,
    default: true,
  },
  suffixText: {
    type: String,
    default: '',
  },
  format: {
    type: Function,
    default: null,
  }
}

export const selectEmit = {
  ["update:modelValue"]: (value: string) => isString(value),
  input: (value: string) => isString(value),
  blur: (e: FocusEvent) => e instanceof FocusEvent,
  clear: () => true,
  change: (value: string) => isString(value),
}